module.exports = __webpack_public_path__ + "img/emo_20.83b1162b.png";